import e from "axios";
//#region src/fetch/http-base-client/create-http-client.ts
function t(t = {}) {
	let { withCredentials: n = !0, headers: r = {}, baseURL: i } = t;
	return e.create({
		withCredentials: n,
		baseURL: i,
		headers: {
			"X-Requested-With": "XMLHttpRequest",
			...r
		}
	});
}
//#endregion
export { t as createHttpClient };
